import { getSessionSaga, reduceLoading, reduceOperation } from 'metrix-common3';
import { call, put } from 'redux-saga/effects';
import { reducePolicyAdjustments } from '../../actions/policy/reducePolicyAdjustments';

export function* applyPolicyAdjustmentSaga(action) {
    try {
        yield put(reduceLoading({ code: 'applyPolicyAdjustment', value: true }));
        const session = yield getSessionSaga();

        const response = yield call(fetch, '/api/policyAdjustment/apply-adjustment', {
            method: 'POST',
            credentials: 'same-origin',
            headers: {
                Accept: 'application/json',
                Authorization: session.authenticationToken.token,
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(action.payload),
        });

        if (!response.ok) {
            console.error('Apply Policy Adjustment API failed with status:', response.status);
            // Create error operation for non-OK responses
            yield put(
                reduceOperation({
                    status: false,
                    code: 'applyPolicyAdjustment',
                    errors: [{ code: 'HTTP_ERROR', value: `HTTP ${response.status}: ${response.statusText}` }],
                }),
            );
            yield put(reduceLoading({ code: 'applyPolicyAdjustment', value: false }));
            return;
        }

        const result = yield call([response, 'json']);

        // Add operation code to identify which operation completed
        yield put(reduceOperation({ ...result.operation, code: 'applyPolicyAdjustment' }));
        yield put(reducePolicyAdjustments(result));
        yield put(reduceLoading({ code: 'applyPolicyAdjustment', value: false }));
    } catch (error) {
        console.log('Error while calling Apply Policy Adjustment API - ', error);
        // Create error operation for exceptions (like JSON parse errors)
        yield put(
            reduceOperation({
                status: false,
                code: 'applyPolicyAdjustment',
                errors: [{ code: 'EXCEPTION', value: error.message || 'An unexpected error occurred' }],
            }),
        );
        yield put(reduceLoading({ code: 'applyPolicyAdjustment', value: false }));
    } finally {
        yield put(reduceLoading({ code: 'applyPolicyAdjustment', value: false }));
    }
}
